import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

export interface NotificacaoListItem {
  publicId: string;
  notificationPublicId: string;
  tipo: string;
  titulo: string;
  descricao: string;
  data: string;
  hora: string;
  lida: boolean;
}

export interface NotificacaoPage {
  count: number;
  rows: NotificacaoListItem[];
}

export interface NotificacaoUnreadCount {
  count: number;
}

@Injectable({
  providedIn: 'root',
})
export class NotificacaoService {
  private url = `${environment.api}/notificacao`;

  constructor(private http: HttpClient) {}

  listar(
    page = 0,
    size = 10,
    lida?: boolean,
    tipo?: string
  ): Observable<NotificacaoPage> {
    let params = new HttpParams()
      .set('page', String(page))
      .set('size', String(size));

    if (lida !== undefined && lida !== null) {
      params = params.set('lida', String(lida));
    }
    if (tipo) {
      params = params.set('tipo', tipo);
    }

    return this.http
      .get<NotificacaoPage>(this.url, { params })
      .pipe(take(1));
  }

  contagemNaoLidas(): Observable<NotificacaoUnreadCount> {
    return this.http
      .get<NotificacaoUnreadCount>(`${this.url}/nao-lidas/contagem`)
      .pipe(take(1));
  }

  marcarLida(publicId: string): Observable<void> {
    return this.http
      .patch(`${this.url}/${publicId}/ler`, null, { responseType: 'text' })
      .pipe(map(() => undefined), take(1));
  }

  marcarTodasLidas(): Observable<void> {
    return this.http
      .patch(`${this.url}/ler-todas`, null, { responseType: 'text' })
      .pipe(map(() => undefined), take(1));
  }
}
